import { useMemo } from 'react';

import { useTranslation } from 'hooks/useTypedTranslation';

export const ROOT_FOLDER_ID = 'root';

export enum LibraryShowFolderType {
  TOP = 'TOP',
  MIXED = 'MIXED'
}

export const useShowFolderOptions = () => {
  const { t } = useTranslation('common');

  return useMemo(
    () => [
      { value: LibraryShowFolderType.TOP, label: t('On Top')! },
      { value: LibraryShowFolderType.MIXED, label: t('Mixed with Files')! }
    ],
    [t]
  );
};
